import React, {Component} from 'react';
import Header from "../../../components/Header/header";
import Layout from "../../../components/Layout/layout";
import content from "../../../assets/temp/content.png";
import './temp.scss';

class Temp extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {
        const {} = this.state;

        return (
            <Layout location={this.props.location}>
                <img className="content-img" src={content} alt=""/>
            </Layout>
        );
    }
}

export default Temp;



// WEBPACK FOOTER //
// ./src/pages/Index/index.js
